<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="120px">
            <el-form-item label="推荐页名称：" prop="recommendationName">
                <el-input v-if="!disabled" v-model.trim="searchForm.recommendationName" maxlength="20"
                          placeholder="请输入推荐页名称(限20字)"
                          clearable></el-input>
                <div v-else>{{ searchForm.recommendationName }}</div>
            </el-form-item>
            <el-form-item label="所属渠道：" prop="channelId">
                <el-select v-if="!disabled" v-model="searchForm.channelId" clearable placeholder="请选择所属渠道"
                           style="width: 100%">
                    <el-option
                            v-for="item in channelIdList"
                            :key="item.id"
                            :label="item.channelName"
                            :value="item.id">
                    </el-option>
                </el-select>
                <div v-else>{{ getChannel(searchForm.channelId) }}</div>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <el-input-number v-if="!disabled" v-model="searchForm.sort" @change="setSort" :min="1"
                                 label="请输入排序"></el-input-number>
                <div v-else>{{ searchForm.sort }}</div>
            </el-form-item>
            <el-form-item label="缩略图：" prop="url">
                <upload v-show="upDateList.length == 0" :uploadAskObj="uploadRequire2" @getDataList="getImgData">
                    <template v-slot:updateStyle>
                        <div style="width: 100px;
                          text-align: center;
                          height: 100px;
                          line-height: 100px;
                          border: 1px dashed #d9d9d9;
                          border-radius: 6px;
                          ">
                            <div class="el-icon-plus" style="
                            font-size: 20px;
                              "></div>
                        </div>
                    </template>
                </upload>
                <div
                        v-for="(item,index) in upDateList" :key="index"
                        style="position: relative;padding-bottom: 10px;width: 110px;margin-right: 15px"
                >
                    <div class="el-icon-error" v-show="!disabled" @click="deleteFile(index)"
                         style="position:absolute; top: -8px;right: -8px;font-size: 16px;z-index: 99;cursor: pointer"></div>
                    <el-image
                            style="width: 100%; height: 110px;"
                            :src="item.netUrl"
                            :fit="'cover'"
                            :preview-src-list="[item.netUrl]"
                    >
                        <div slot="error" class="image-slot">
                            <el-image
                                    style="width: 100%; height: 110px;"
                                    :src="require('@/assets/img/default.png')"
                                    :fit="'cover'">
                            </el-image>
                        </div>
                    </el-image>
                    <el-tooltip class="item" effect="dark" :content="item.fileName" placement="top">
                        <div style="font-size: 12px;width: 100%;margin-top: -18px;" class="omit">{{
                            item.fileName
                            }}
                        </div>
                    </el-tooltip>
                </div>
                <div class="updateSize">
                    建议尺寸：{{ uploadRequire2.size }}，
                    单张图片：{{ uploadRequire2.megaNum }}M以内，
                    建议格式：{{ uploadRequire2.fileType.join('、') }}。
                </div>
            </el-form-item>
            <el-form-item label="显示状态：" prop="status">
                <el-switch
                        v-model="searchForm.status"
                        active-value="0"
                        inactive-value="1">
                </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Upload from "@/components/Upload/Upload";

export default {
    name: "addSuggest",
    components: {Upload},
    data() {
        return {
            title: '新增推荐页资源',
            visible: false,
            disabled: false,
            searchForm: {
                recommendationName: '',
                channelId: '',
                sort: 1,
                url: '',
                status: '1',
            },
            rules: {
                recommendationName: [
                    {required: true, message: '请输入推荐页名称', trigger: 'blur'}
                ],
                channelId: [
                    {required: true, message: '请选择所属渠道', trigger: 'change'}
                ],
                url: [
                    {required: true, message: '请上传缩略图', trigger: 'blur'}
                ]
            },
            channelIdList: [],

            upDateList: [],
            // 缩略图上传要求
            uploadRequire2: {
                list: [],
                size: '16:9',
                showFile: false, // 是否显示已上传文件列表
                count: 1, // 上传文件数量 0表示不限制文件的数量
                fileType: ['jpg', 'png', 'jpeg', 'gif'],
                megaNum: 10,
                showTips: true,
                customUploadStyle: true,
            },
        }
    },

    methods: {
        //0新增/1详情/2编辑按钮
        init(num, row, channelNameList) {
            this.visible = true
            this.disabled = false
            this.channelIdList = channelNameList
            this.searchForm = {
                recommendationName: '',
                channelId: '',
                sort: 1,
                url: '',
                status: '1',
            }
            this.upDateList = []
            this.uploadRequire2.list = []
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (num == 0) {
                this.title = '新增推荐页资源'
            }
            if (num == 1) {
                this.title = '详情推荐页资源'
                this.disabled = true
                this.getDetail(row.id)
            }
            if (num == 2) {
                this.title = '编辑推荐页资源'
                this.getDetail(row.id)
            }
        },

        getDetail(id) {
            this.$axios(this.api.dyygRelease.releasesRecommendationGetById + id, {}).then(data => {
                if (data && data.status) {
                    this.searchForm = data.data
                    this.upDateList.push(
                        {
                            netUrl: data.data.url,
                            fileName: '',
                        }
                    )
                }
            })
        },

        getChannel(channelId) {
            let row = this.channelIdList.filter(item => {
                return item.id == channelId
            })
            if (row.length) {
                return row[0].channelName
            }
        },

        setSort(value) {
            if (!value) {
                this.searchForm.sort = 1
            }
        },

        // 获取上传缩略图数据
        getImgData(data) {
            this.upDateList = [
                {
                    netUrl: data.response.data,
                    fileName: data.name,
                }
            ]
            this.searchForm.url = data.response.data
        },

        deleteFile(index) {
            this.$confirm('此操作将删除该缩略图, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.upDateList.splice(index, 1)
                this.uploadRequire2.list = []
                this.searchForm.url = ''
            })
        },

        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.dyygRelease.releasesRecommendationUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.dyygRelease.releasesRecommendationSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.updateSize {
    margin-top: 10px;
    font-size: 12px;
    line-height: 14px;
}
</style>